import { webSentryClientOptions } from "@agilix/ui/webSentry"
import * as Sentry from "@sentry/astro"

Sentry.init({
  // The shared options carry the `web` DSN, which the tunnel route accepts by exact match.
  ...webSentryClientOptions("zawody"),
  tunnel: "/api/monitoring",
  integrations: [
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})
